import { Typography } from "@mui/material";
import { Dialog } from "../../components/dialogs/Dialog";
import { ITask } from "../../interfaces/Task";
import { useLocale } from "../../providers/LocaleProvider";

const ImportTaskListDialog = (props: any) => {
  const {
    theme,
    onClose,
    open = false,
    onImport = () => {},
    tasks = [],
    isLoading = false,
    hasCompetencies
  } = props;
  const { translate } = useLocale();

  return (
    <Dialog
      open={open}
      theme={theme}
      onClose={onClose}
      fullWidth={true}
      maxWidth='sm'
      title={translate("settings.importTasks")}
      actions={[
        {
          label: hasCompetencies
            ? translate("common.continue")
            : translate("settings.confirmAndImport"),
          primary: true,
          variant: "filled",
          disabled: isLoading,
          onClick: onImport,
          isLoading: isLoading
        },
        {
          label: translate("common.cancel"),
          onClick: onClose
        }
      ]}
    >
      <Typography>
        {translate(
          tasks.length === 1
            ? "settings.importTasksMessageSingle"
            : "settings.importTasksMessageMultiple"
        )}
      </Typography>

      <ul>
        {tasks.map((task: any) => (
          <li key={task.id}>
            <Typography>{task.name}</Typography>
          </li>
        ))}
      </ul>
    </Dialog>
  );
};

export default ImportTaskListDialog;
